import { Redirect, Route, Switch } from "react-router";
import { getPath } from "common/routing";
import AppSelector from "./AppSelector";
import RequestForm from "./Authentication/PasswordReset/RequestForm";
import UserLoginPage from "./Authentication/UserLoginPage";
import { AuthContextProvider } from "./Authorization/AuthContext";
import { UnauthedRoute } from "./Authorization/UnAuthedRoute";
import { MainRouteProps } from "./types";
import UserInvite from "./UserInvite";

export const AccountSubdomainRoutes = (props: MainRouteProps) => {
  const landingPage =
    props.user || props.admin ? getPath("map") : getPath("login");
  return (
    <Switch>
      <Redirect exact from="/" to={landingPage} />
      <UnauthedRoute
        {...props}
        path={getPath("provideCredentials")}
        routeName="provideCredentials"
        component={UserLoginPage}
      />
      <Route path={getPath("acceptInvite")} component={UserInvite} />
      <Route path={getPath("passwordReset")} component={RequestForm} />
      <AuthContextProvider {...props}>
        <AppSelector />
      </AuthContextProvider>
    </Switch>
  );
};
